/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { updateProfile } from '../../config/updateProfile.config';

import axios from 'axios';
import { Graphql } from '@common/graphql';
import { REINVITE_DIRECTOR, REVERT_DIRECTOR } from '../../api/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';
import toast from 'react-hot-toast';
import { getErrorMessage } from '@/utils/error.message';
import { error } from 'console';

export interface IreinviteDirectorMethods extends IPluginMethodMap {
  reinviteDirector(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class reinviteDirectorService implements IAgentPlugin {
  readonly methods: IreinviteDirectorMethods;

  constructor() {
    this.methods = {
      reinviteDirector: this.reinviteDirector.bind(this),
    };
  }

  async reinviteDirector(args: any) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    try {
      if (client) {
        console.log(client);
        const res = await client
          .mutation(
            args?.buttonText === 'ReInvite'
              ? REINVITE_DIRECTOR
              : REVERT_DIRECTOR,

            {
              email: args?.email,
            }
          )
          .toPromise();
        if (args?.buttonText === 'ReInvite') {
          if (res?.data?.reinviteDirector) {
            return {
              data: res?.data?.reinviteDirector,
            };
          }
        } else {
          if (res?.data?.revertDirectorFromOrg) {
            return {
              data: res?.data?.revertDirectorFromOrg,
            };
          }
        }
        console.log('companysetperror-->inservice', res);
        getErrorMessage(res?.error);
        throw res?.error?.graphQLErrors?.[0];
      }
    } catch (err: any) {
      // getErrorMessage(err)
      throw Error(err?.response?.data?.error?.display_message);
    }
  }
}
